import { render, staticRenderFns } from "./tips-toast.vue?vue&type=template&id=60548a92&scoped=true&"
import script from "./tips-toast.vue?vue&type=script&lang=js&"
export * from "./tips-toast.vue?vue&type=script&lang=js&"
import style0 from "./tips-toast.vue?vue&type=style&index=0&id=60548a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60548a92",
  null
  
)

export default component.exports